module.exports = __webpack_public_path__ + "static/Gotham-Black-14b3a355f612d6181e891efd2c798b5f.otf";